export default __webpack_public_path__ + "media/search.de9e0c29.svg";